export { default } from './product-specs-mobile-drawer-footer';
